'use strict';

/* Directives */


angular.module('FlexyBeautyApp.directives').
  directive('appVersion', ['version', function(version) {
    return function(scope, elm, attrs) {
      elm.text(version);
    };
  }])
  .directive('fbwrappermenu', ['$timeout','$parse',
        function($timeout,$parse) {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    var ngMenuItemGet = $parse(attrs.fbwrappermenu);
                    var categoryView = null;
                    if (ngMenuItemGet && ngMenuItemGet(scope))
                        categoryView = ngMenuItemGet(scope);
                    var mouseEnterProcess = false;
                    element.bind('mouseenter', function() {
                        mouseEnterProcess = true;
                        if (categoryView)
                            categoryView.showMenu=true;
                        $timeout(function(){
                            mouseEnterProcess = false;
                        },200);//when we use a touch pad : mousenter and mouseup can occur one after the second. Then if mouse enter display the menu, mouseup mustnot hide.
                    });
                    element.bind('mouseleave', function() {
                        if (categoryView)
                            categoryView.showMenu=false;
                        scope.$apply();
                    });
                    element.bind('mouseup', function()
                    {
                        if (!mouseEnterProcess)
                        {
                            scope.setCurrentCategoryView(scope.ad.view.categoryRootView,true);
                            scope.$apply();
                        }
                    });

                }
            };
        }])

    .directive("tooltipsModal", function() {
        return {
            restrict: 'E',
            scope: {
                position: '@tooltipsPosition',
                title: '@tooltipsTitle',
                description: '@tooltipsDescription',
                picture: '@tooltipsPicture',
                button: '@tooltipsButton'
            },
            templateUrl: '/partials-web/editor/tooltips.html'
        }
    })

     .directive('ngKeydown', function() {
    return {
        restrict: 'A',
        link: function(scope, elem, attrs) {
            // this next line will convert the string
            // function name into an actual function
            var functionToCall = scope.$eval(attrs.ngKeydown);
            elem.on('keydown', function(e){
                // on the keydown event, call my function
                // and pass it the keycode of the key
                // that was pressed
                // ex: if ENTER was pressed, e.which == 13
                functionToCall(e);
            });
        }
    };
});




// WEBPACK FOOTER //
// ./js/directives/directivesWebSite.js